import { ColumnDef } from "@tanstack/react-table"

import { SMSTemplatedType } from "@/types/index"

import { DataTableColumnHeader } from "../../data-table"
import { SMSTemplatedMessagesOperations } from "../operations/edit-sms-templated-operations"

export const smsTemplatedColumns: ColumnDef<SMSTemplatedType>[] = [
  {
    accessorKey: "zone",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Zone" />
    ),
    cell: ({ row }) => {
      const value = row.original.zone
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "due_reminder_type",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Due Reminder Type" />
    ),
    cell: ({ row }) => {
      const value = row.original.due_reminder_type
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "subject",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Subject" />
    ),
    cell: ({ row }) => {
      const value = row.original.subject
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "header",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Header" />
    ),
    cell: ({ row }) => {
      const value = row.original.header
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "actions",
    header: () => {
      return <div className="text-center dark:text-white">Actions</div>
    },
    cell: ({ row }) => {
      return (
        <div className="px-4 py-2 text-center md:py-0 md:text-center">
          <SMSTemplatedMessagesOperations data={row.original} />
        </div>
      )
    },
  },
]
